
import Component from 'vue-class-component';
import moduleStore from '../../store';
import Vue from 'vue';
import PageState from '../../store/state';
let self = null
/**components**/
@Component({
	props: {
    title: {
      // 选中值信息
      type: String,
      default: "提示",
    },
		content:{
      // 选中值信息
      type: String,
      default: "",
    },
		showPopup:{
      // 是否显示
      type: Boolean,
      default: false
    },
		confirmText:{
      // 确认按钮显示
      type: String,
      default: "确定",
    },
		cancelText:{
      // 取消按钮显示
      type: String,
      default: "取消",
    },
		confirmFun:{
			type:Function,
			default:()=>{
				return self.closePopupMsg()
			}
		},
		cancelFun:{
			type:Function,
			default:()=>{
				return self.closePopupMsg()
			}
		},
	}
})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class currencyPopupComponent extends Vue {
    state: any = null;
    created(moduleData: IinjectDatas) {
			self = this
			this.state = <PageState>moduleData.state;
		}

	hideSpeakerBuyWindow(){
		this.state.buyVoicePopupVisible = false
		this.state.selectPaySpeaker = null
	}
	closePopupMsg(){
		this.$emit('update:showPopup',false)
	}
}